import React from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useContactPageData from '../../../cmsHooks/useContactPageData'

import { FullWidthSection, ContentContainer, Center } from '../../layout'
import {
  ActionButton,
  SidePageTextBox,
  FormLabel,
  FormTextInput,
  FormTextArea,
} from '../../ui'
import EmailerForm from '../../misc/EmailerForm'
import device from '../../../utilities/device'

const Para = styled.p`
  font-size: 22px;
  margin-top: 20px;
  line-height: 1.4em;
  &:last-of-type {
    margin-bottom: 40px;
  }
`

const CharCount = styled.p`
  font-size: 16px;
  margin-bottom: 50px;
`

const Spacer = styled.div`
  height: 100px;
`
const NameFields = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  > div {
    flex-basis: 45%;
  }
`

const FormRow = styled.div`
  margin-bottom: 30px;
`

const Contact = (): JSX.Element => {
  const data = useContactPageData()

  return (
    <FullWidthSection>
      <ContentContainer verticalPadding={'40px'}>
        <Center cross>
          <SidePageTextBox>
            <h1>
              <CMS.Text name="Contact headline" data={data} />
            </h1>
            <Para>
              <CMS.Text name="Instructions" data={data} />
            </Para>
            <EmailerForm
              {...{
                subjectCMSName: 'Contact subject',
                siteCMSName: 'Site name',
                bodyCMSName: 'Contact body',
                buttonTextCMSName: 'Contact button',
                submittingButtonTextCMSName: 'In-progress button text',
                successMessageCMSName: 'Contact success text',
                errorMessageCMSName: 'Error text',
                submitUrlCMSName: 'Submit URL',
                formAriaLabelCMSName: 'Contact aria label',
              }}
            >
              <FormRow>
                <NameFields>
                  <div>
                    <FormLabel>
                      <CMS.Text name="First name label" data={data} />
                      <FormTextInput type="text" name="First name" required />
                    </FormLabel>
                  </div>
                  <div>
                    <FormLabel>
                      <CMS.Text name="Last name label" data={data} />
                      <FormTextInput type="text" name="Last name" required />
                    </FormLabel>
                  </div>
                </NameFields>
              </FormRow>
              <FormRow>
                <FormLabel>
                  <CMS.Text name="Email label" data={data} />
                  <FormTextInput type="email" name="Email" required />
                </FormLabel>
              </FormRow>
              <FormRow>
                <FormLabel>
                  <CMS.Text name="Organization label" data={data} />
                  <FormTextInput type="text" name="Organization" />
                </FormLabel>
              </FormRow>
              <FormLabel>
                <CMS.Text name="Comment label" data={data} />
                <FormTextArea
                  name="Comment or question"
                  maxLength={500}
                  required
                />
              </FormLabel>
              <FormRow>
                <CharCount>
                  <CMS.Text name="Text limit" data={data} />
                </CharCount>
              </FormRow>
            </EmailerForm>
          </SidePageTextBox>
          <Spacer />
        </Center>
      </ContentContainer>
    </FullWidthSection>
  )
}

export default Contact
